import { Card, Col, Row } from 'antd';
import '@features/Webpage/homepage.css';

import { WebsiteFooter } from './Footer';
import {
  KFS_Luzon_Mel,
  KFS_Luzon_Syd,
  KFS_Min_Mel,
  KFS_Min_Syd,
  KFS_Vis_Mel,
  KFS_Vis_Syd,
  kfsmnlsyd,
  LUZ_Adeliade,
  Min_Adeliade,
  MNL_Adelaide,
  mnlMel,
  VIS_Adeliade,
} from 'common/images';
import { useHistory } from 'react-router';
import { PATHS } from '@routing/routes';
export const PricingAdelaide = () => {
  const history = useHistory();
  return (
    <>
      <Row gutter={0} align="middle" className="headerMainRow">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="webPageHeaderTextAboutUs">
          <p className="headertextAboutUs">Our rates</p>
        </Col>
      </Row>

      <Row justify="space-between">
        <Col sm={24} className="">
          <div className="">
            <a className="normal-font dInlineBlock" onClick={() => history.push(PATHS.PricingMel.path)}>
              <h3 className="normalfontweight melsydlbl"> Melbourne </h3>
            </a>
            <span className="normal-font dInlineBlock verticalBar"> | </span>
            <a className="normal-font dInlineBlock" onClick={() => history.push(PATHS.PricingSyd.path)}>
              <h3 className="normalfontweight melsydlbl"> Sydney</h3>
            </a>
            <span className="normal-font dInlineBlock verticalBar"> | </span>
            <a className="normal-font dInlineBlock underline">
              <h3 className="normalfontweight melsydlbl"> Adelaide</h3>
            </a>
          </div>
        </Col>
      </Row>
      <div className="melbourneDiv">
        <p className="mtb listedprice">
          <span className="textColor">
            * Prices below apply to Metro Adelaide. For other areas, please contact our customer service for cost
            details.
          </span>
          <br />
          <span className="textColor ">* Additional charges may apply for remote or island transfers.</span> <br />
          <span className="textColor ">
            * Delivery timeframe is determined from the departure date of the container from the port of origin. Arrival
            dates are subject to change depending on transit conditions, and we’ll keep you informed of any updates.
          </span>
          <br />
          <span className="textColor ">* Empty boxes are purchased separately at $12 each.</span>
        </p>
        <Row gutter={24}>
          <Col xs={19} sm={12} md={12} lg={8} xl={6} className="serviceCol">
            <Card
              title={
                <div>
                  Biyaheng Metro Manila <br /> $130.00
                </div>
              }
              cover={<img alt="example" src={MNL_Adelaide} className="serviceImg" />}
            >
              <div className="center-text">
                <h3 className="font14px"> 5 to 6 Weeks</h3>
              </div>
            </Card>
          </Col>
          <Col xs={19} sm={12} md={12} lg={8} xl={6} className="serviceCol">
            <Card
              title={
                <div>
                  Biyaheng Luzon <br /> $140.00
                </div>
              }
              cover={<img alt="example" src={LUZ_Adeliade} className="serviceImg" />}
            >
              <div className="center-text">
                <h3 className="font14px"> 7 to 8 Weeks</h3>
              </div>
            </Card>
          </Col>
          <Col xs={19} sm={12} md={12} lg={8} xl={6} className="serviceCol">
            <Card
              title={
                <div>
                  Biyaheng Visayas <br /> $160.00
                </div>
              }
              cover={<img alt="example" src={VIS_Adeliade} className="serviceImg" />}
            >
              {' '}
              <div className="center-text">
                <h3 className="font14px"> 8 to 9 Weeks </h3>
              </div>
            </Card>
          </Col>
          <Col xs={19} sm={12} md={12} lg={8} xl={6} className="serviceCol">
            <Card
              className="cardService"
              title={
                <div>
                  Biyaheng Mindanao <br /> $170.00
                </div>
              }
              cover={<img alt="example" src={Min_Adeliade} className="serviceImg" />}
            >
              {' '}
              <div className="center-text">
                <h3 className="font14px"> 8 to 9 Weeks</h3>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <br />
      <Row gutter={0} align="middle">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <WebsiteFooter />
        </Col>
      </Row>
    </>
  );
};
